export default __webpack_public_path__ + "static/media/imp.f7516deb.jpg";